import { Text } from "@fluentui/react-components";
import { SparkleRegular } from "@fluentui/react-icons";
import { useWorkspaceInfoBannerStyles } from "./WorkspaceInfoBanner.styles";
import { IWorkspaceInfoBannerProps } from "./WorkspaceInfoBanner.types";

export const WorkspaceInfoBanner = ({
  children,
}: IWorkspaceInfoBannerProps): JSX.Element => {
  const styles = useWorkspaceInfoBannerStyles();

  return (
    <div className={styles.banner}>
      <SparkleRegular className={styles.icon} aria-hidden="true" />
      <Text className={styles.text}>{children}</Text>
    </div>
  );
};
